'use strict';

import angular from 'angular';
import _ from 'lodash'

angular.module('publishToDashboards.services')
    .service('DashboardsDataPublisherHelper', DashboardsDataPublisherHelper)
    .service('DashboardsDataPublisherFactory', DashboardsDataPublisherFactory)

/**
 * @ngInject
 */
function DashboardsDataPublisherHelper($ioAlert, DashboardsDataPublisherFactory) {
    return {
        publishData() {
            DashboardsDataPublisherFactory.publishData().then(function (data) {
                if (!data) {
                    $ioAlert.show('', 'No data returned from the server', 'error')
                }

                _.each(data.log, function(entry) {
                    entry.success ?
                        $ioAlert.show('', entry.message, 'success') :
                        $ioAlert.show('', entry.message, 'error')
                })
            }, function () {
                $ioAlert.show('', 'Something went wrong! Please try again.', 'error')
            })
        }
    }
}

/**
 * @ngInject
 */
function DashboardsDataPublisherFactory(IORestangular) {
    return {
        publishData() {
            return IORestangular.all('cron/createDynamicAttrTable').customGET()
        }
    }
}